<script setup lang="ts">
import PostComponent from '@ui/composites/PostComponent/PostComponent.vue'
import { useHowtoEntriesPage } from '~/composables/content/how-to'

definePageMeta({
  layout: 'menu',
})

const { data } = await useHowtoEntriesPage()

const { t } = useI18n()
const localeRoute = useLocaleRoute()

const {
  public: { siteUrl },
} = useRuntimeConfig()

useSeoMeta({
  title: t('how-to-title'),
  description: t('how-to-description'),
  ogTitle: t('how-to-title'),
  ogDescription: t('how-to-description'),
  ogImage: `${siteUrl}/images/blog/bg.webp`,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogType: 'website',
  twitterTitle: t('how-to-title'),
  twitterDescription: t('how-to-description'),
  twitterImage: `${siteUrl}/images/blog/bg.webp`,
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <div class="flex flex-col relative h-91.75">
    <h1 class="pt-40.5 text-center tracking-wide text-[1.75rem]">
      {{ t('how-to-h1') }}
    </h1>
    <img
      alt="Blog"
      class="absolute top-0 left-0 right-0 h-91.75 w-full object-cover -z-1"
      src="/images/blog/bg.webp"
    />
  </div>
  <div class="container center mx-auto px-4 mt-10">
    <div v-if="data.length" class="flex flex-col gap-8 max-w-237.25 mx-auto">
      <NuxtLink
        v-for="entry in data"
        :key="entry.documentId"
        :to="localeRoute('/how-to/' + entry.slug)"
      >
        <PostComponent :image="entry.image.url">
          <template #dateTime>
            <UiDateTime v-if="entry.date" :value="entry.date" />
          </template>
          <template #title>
            {{ entry.title }}
          </template>
          <template #description>
            {{ entry.description }}
          </template>
        </PostComponent>
      </NuxtLink>
    </div>

    <p v-else>No entries found</p>
  </div>
</template>
